import React, { useEffect, useRef, useState } from 'react';
import FreeCamToggle from './FreeCamToggle';
import MuteToggle from './MuteToggle';

interface InfoOverlayProps {
    visible: boolean;
}

const NAME_TEXT = 'Mr. Engagement Corp.';
const TITLE_TEXT = 'Optimizando tu Dopamina.';
const MULTIPLIER = 1;

const InfoOverlay: React.FC<InfoOverlayProps> = ({ visible }) => {
    const visRef = useRef(visible);
    const [nameText, setNameText] = useState('');
    const [titleText, setTitleText] = useState('');
    // Session start time
    const [startTime] = useState<number>(Date.now());
    const [timeText, setTimeText] = useState('');
    const [textDone, setTextDone] = useState(false);
    const [volumeVisible, setVolumeVisible] = useState(false);
    const [freeCamVisible, setFreeCamVisible] = useState(false);

    // Helper to format seconds into HH:MM:SS
    const formatTimeLost = (start: number) => {
        const now = Date.now();
        const diff = Math.floor((now - start) / 1000);
        const hours = Math.floor(diff / 3600).toString().padStart(2, '0');
        const minutes = Math.floor((diff % 3600) / 60).toString().padStart(2, '0');
        const seconds = (diff % 60).toString().padStart(2, '0');
        return `TIEMPO PERDIDO: ${hours}:${minutes}:${seconds}`;
    };

    const typeText = (
        i: number,
        curText: string,
        text: string,
        setText: React.Dispatch<React.SetStateAction<string>>,
        callback: () => void,
        refOverride?: React.MutableRefObject<string>
    ) => {
        if (refOverride) {
            text = refOverride.current;
        }
        if (i < text.length) {
            setTimeout(() => {
                if (visRef.current === true)
                    window.postMessage(
                        { type: 'keydown', key: `_AUTO_${text[i]}` },
                        '*'
                    );

                setText(curText + text[i]);
                typeText(
                    i + 1,
                    curText + text[i],
                    text,
                    setText,
                    callback,
                    refOverride
                );
            }, Math.random() * 50 + 50 * MULTIPLIER);
        } else {
            callback();
        }
    };

    useEffect(() => {
        if (visible && nameText == '') {
            setTimeout(() => {
                typeText(0, '', NAME_TEXT, setNameText, () => {
                    typeText(0, '', TITLE_TEXT, setTitleText, () => {
                        // Start showing the timer immediately after title
                        setTextDone(true);
                    });
                });
            }, 400);
        }
        visRef.current = visible;
    }, [visible]);

    useEffect(() => {
        if (textDone) {
            // Initial set
            setTimeText(formatTimeLost(startTime));

            setTimeout(() => {
                setVolumeVisible(true);
                setTimeout(() => {
                    setFreeCamVisible(true);
                }, 250);
            }, 250);
        }
    }, [textDone]);

    useEffect(() => {
        window.postMessage({ type: 'keydown', key: `_AUTO_` }, '*');
    }, [freeCamVisible, volumeVisible]);

    useEffect(() => {
        let interval: NodeJS.Timeout;
        if (textDone) {
            interval = setInterval(() => {
                setTimeText(formatTimeLost(startTime));
            }, 1000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [textDone, startTime]);

    return (
        <div style={styles.wrapper}>
            {nameText !== '' && (
                <div style={styles.container}>
                    <p>{nameText}</p>
                </div>
            )}
            {titleText !== '' && (
                <div style={styles.container}>
                    <p>{titleText}</p>
                </div>
            )}
            {textDone && (
                <div style={styles.lastRow}>
                    <div
                        style={Object.assign(
                            {},
                            styles.container,
                            styles.lastRowChild,
                            styles.timerContainer
                        )}
                    >
                        <p style={styles.timerText}>{timeText}</p>
                    </div>
                    {volumeVisible && (
                        <div style={{ ...styles.lastRowChild, pointerEvents: 'auto' }}>
                            <MuteToggle />
                        </div>
                    )}
                    {freeCamVisible && (
                        <div style={{ ...styles.lastRowChild, pointerEvents: 'auto' }}>
                            <FreeCamToggle />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

const styles: StyleSheetCSS = {
    container: {
        background: '#000000',
        padding: 4,
        paddingLeft: 16,
        paddingRight: 16,
        textAlign: 'center',
        display: 'flex',
        marginBottom: 4,
        boxSizing: 'border-box',
    },
    wrapper: {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    },
    blinkingContainer: {
        // width: 100,
        // height: 100,
        marginLeft: 8,
        paddingBottom: 2,
        paddingRight: 4,
    },
    lastRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    lastRowChild: {
        marginRight: 4,
    },
    timerContainer: {
        // Optional: add specific container styles for the timer if needed
    },
    timerText: {
        color: '#FB0404',
        // Simple blinking effect using CSS animation would be better in a real CSS file,
        // but for inline styles we can't easily do keyframes without a style tag or external css.
        // We'll stick to red color as requested, and maybe add a text shadow for "glow".
        textShadow: '0 0 5px #FB0404',
        fontWeight: 'bold',
    }
};

export default InfoOverlay;
